import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import CmsContext from 'context/CmsContext';
import * as c from '../constant';
import * as actions from '../action';

function CreateModal({
  createInput,
  createInputNumber,
  createRequirement,
  formData,
  setFormData,
  getRequirementList,
  history,
  showRequirement,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const { name, description, note, ...restFormData } = formData;

    createRequirement(
      {
        name,
        description,
        note,
        ...(_.get(CMS_VARIABLES, 'LGU_NAME') === 'Las Piñas' && restFormData),
      },
      ({ data }) => {
        setModal({ isOpen: false });
        getRequirementList();
        history.push(`/general-settings/requirements/${_.get(data, 'id')}`);
        showRequirement(data.id);
      }
    );
  };

  useEffect(() => {
    setFormData({
      ...c.FORM_DATA,
    });
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true, minLength: 3 }
            )}
          </div>
          {_.get(CMS_VARIABLES, 'LGU_NAME') === 'Las Piñas' && (
            <>
              <div className="col-6 form-group">
                {createInputNumber(
                  { key: 'quantity', label: 'Quantity:' },
                  { minLength: 1 }
                )}
              </div>
              <div className="d-flex col-6 form-group align-items-center pt-4">
                <label htmlFor="last_name" className="form-label pt-2">
                  Required: &nbsp;
                </label>
                <input
                  name="is_required"
                  type="checkbox"
                  checked={_.get(formData, 'is_required')}
                  onChange={onChange}
                />
              </div>
            </>
          )}
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput({ key: 'note', label: 'Note:' }, { minLength: 3 })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  createRequirement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
